import { NitroModules } from "react-native-nitro-modules";
import { rethrowNativeError } from "../nativeError";
var hybrid;
function native() {
  hybrid !== null && hybrid !== void 0 ? hybrid : hybrid = NitroModules.createHybridObject("OneShare");
  return hybrid;
}
function share(items) {
  return native().share(items).catch(rethrowNativeError);
}
var Share = Object.freeze({
  share
});
export {
  Share
};
//# sourceMappingURL=index.native.js.map
